import { AdminModalFooterProps } from './admin-modal-footer-props';
import React from 'react';
import styled from 'styled-components';

type ComponentType = React.FunctionComponent<AdminModalFooterProps>;

export const AdminModalFooter = styled.div<ComponentType>`
  padding: 0 1rem;
  margin-top: 2rem;
`;
